import axios from 'axios'
import { Auth } from 'aws-amplify'

export const getApiClient = (baseURL, useAccessToken = false) => {
  const ApiClient = axios.create({ baseURL })

  ApiClient.interceptors.request.use(async (request) => {
    const credentials = await Auth.currentSession()
    request.headers = {
      ...request.headers,
      //env: process.env.REACT_APP_APP_ENV,
      Authorization: useAccessToken
        ? credentials.getAccessToken().getJwtToken()
        : credentials.getIdToken().getJwtToken()
    }
    return request
  })

  ApiClient.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      // if (error.response && [401, 403].includes(error.response.status)) {
      //   //await Auth.signOut()
      //   return
      // }
      return Promise.reject(error)
    }
  )

  return ApiClient
}

//export const getFetchAPi
